import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function numberValidator(onlyPositive = false): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    const stringValue = String(control.value).trim().replace(',', '.');
    const numericValue = Number(stringValue);

    if (isNaN(numericValue) || !isFinite(numericValue)) {
      return {
        numberValidator: 'Waarde moet getal zijn',
      };
    }

    if (onlyPositive && numericValue < 0) {
      return {
        positiveNumberValidator: 'Waarde moet een positief getal zijn',
      };
    }

    return null;
  };
}
